import { Action, ThunkAction } from '@reduxjs/toolkit';

import * as hooks from './hooks';
import { rootReducer, store } from './store';

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const { useAppDispatch, useAppSelector } = hooks;
